import { useSelector, useDispatch } from 'react-redux';
import {
  List,
  ListItemButton,
  ListItemText,
  IconButton,
  Typography,
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import { RootState } from '../../store/store';
import { removeShape, selectShape } from '../../store/slices/missionPlannerSlice';
import { shapeAreaM2, formatArea } from '../../utils/geometry';

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/** Panel list of drawn shapes with live area; select or delete each. */
export const ShapeList: React.FC = () => {
  const dispatch = useDispatch();
  const shapes = useSelector(
    (state: RootState) => state.missionPlanner.draft.shapes
  );
  const selectedId = useSelector(
    (state: RootState) => state.missionPlanner.selectedShapeId
  );

  if (shapes.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No coverage areas yet. Pick a shape above, then drag on the map.
      </Typography>
    );
  }

  return (
    <List dense aria-label="Coverage areas">
      {shapes.map((shape, i) => (
        <ListItemButton
          key={shape.id}
          selected={shape.id === selectedId}
          onClick={() => dispatch(selectShape(shape.id))}
          sx={{ minHeight: 44, borderRadius: 1 }}
        >
          <ListItemText
            primary={`${capitalize(shape.kind)} ${i + 1}`}
            secondary={formatArea(shapeAreaM2(shape))}
          />
          <IconButton
            edge="end"
            aria-label={`Delete ${shape.kind} ${i + 1}`}
            onClick={(e) => {
              e.stopPropagation();
              dispatch(removeShape(shape.id));
            }}
            sx={{ width: 44, height: 44 }}
          >
            <Delete fontSize="small" />
          </IconButton>
        </ListItemButton>
      ))}
    </List>
  );
};
